import React from 'react';

import * as ST from './styled';

interface IProps {
    isOpen: boolean,
    withDividingBorder: boolean,
    children: JSX.Element | JSX.Element[] | string,
}

const Body = ({ isOpen, withDividingBorder, children, ...rest }: IProps): JSX.Element => {
    return <ST.Body isOpen={isOpen} {...rest}>
        {withDividingBorder && <ST.Border/>}
        {children}
    </ST.Body>;
};

export default Body;
